import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["src"]

import {onMounted, ref, watch} from "vue";

	
export default /*#__PURE__*/_defineComponent({
  __name: 'ImageComponent',
  props: {
    src: {}
  },
  setup(__props: any) {

	const props = __props;

	const url = ref('');
	const available = ref(false);

	onMounted(() => {
		loadImage();
	});

	watch(() => props.src, () => {
		loadImage();
	});

	async function loadImage() {
		url.value = process.env.VUE_APP_API_URL.replace('/api/', '/images/drivers/') + props.src;
		setTimeout(() => {
			checkIfImageExists(url.value, exists => {
				available.value = exists;
			});
		}, 1);
	}

	function checkIfImageExists(url: string, callback: () => void) {
		const img = new Image();
		img.src = url;

		if(img.complete) {
			callback(true);
		} else {
			img.onload = () => {
				callback(true);
			};

			img.onerror = () => {
				callback(false);
			};
		}
	}


return (_ctx: any,_cache: any) => {
  return (available.value)
    ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: url.value
      }, null, 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})